
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFDA44","d":"M0 0h512v341.34H0z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M0 0h170.66v341.34H0zM341.34 0H512v341.34H341.34z"}})]),_c('path',{attrs:{"d":"M325.74 101.02l-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"}})])
          )
        }
      }
    